import { supabase } from "@/integrations/supabase/client";
import { useToast } from "@/hooks/use-toast";

interface LeadData {
  name: string;
  email: string;
  phone: string;
}

export const useAutoRegistration = () => {
  const { toast } = useToast();

  const autoRegisterLead = async (leadData: LeadData) => {
    // Check if already logged in
    const { data: { user } } = await supabase.auth.getUser();
    if (user) return; // Already authenticated

    try {
      // Try to sign up the user (auto-confirm is enabled)
      const { data, error } = await supabase.auth.signUp({
        email: leadData.email.trim(),
        password: crypto.randomUUID(), // Random password
        options: {
          emailRedirectTo: window.location.href,
          data: {
            full_name: leadData.name.trim(),
            phone: leadData.phone.trim(),
          },
        },
      });

      if (error?.message?.includes("already registered")) {
        // User exists - send magic link for seamless login
        await supabase.auth.signInWithOtp({
          email: leadData.email.trim(),
          options: {
            emailRedirectTo: window.location.href,
          },
        });
        toast({
          title: "Welcome back!",
          description: "Check your email for a link to sign in.",
        });
      } else if (data?.user) {
        // New user created and auto-logged in
        toast({
          title: "Account created!",
          description: "You can now save properties and track your activity.",
        });
      }
    } catch (authError) {
      console.log("Auto-registration skipped:", authError);
    }
  };

  return { autoRegisterLead };
};
